import { useGetEmployeeQuery, useGetQualificationsQuery, useGetTasksQuery } from '../../../../api/plamo-api'
import { Badge, Breadcrumb, Tabs, TabsProps } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { HomeOutlined } from '@ant-design/icons';
import EmployeeMainForm from './employee-main-form';
import EmployeeAssignment from './employee-assignment';
import { useMemo } from 'react';

import EmployeeContracts from './employee-contracts';
import Comments from '../../fragments/comments';
import EmployeeBalanceSheet from './employee-balance-sheet';
import styled from 'styled-components';
import { IconCircleUserSolid } from '../../../../icon';
import EmployeeSettlement from './employee-settlement';
import EmployeeSalaries from './employee-salaries';
import EmployeeQualifications from './employee-qualifications';
import EmployeeAbsences from './employee-absences';
import Tasks from '../../fragments/tasks';
import EmployeeCalendar from './employee-calendar';
import dayjs from 'dayjs';

const TabsStyled = styled(Tabs)`
  flex: 1;
  overflow: hidden;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function EmployeeDetailsPage() {
  
  const { id, subpage, subsubpage, subsubsubpage } = useParams();
  console.log("Subpage", subpage, subsubpage);
  const employeeId = useMemo(() => parseInt(id || "") || undefined, [id])
  const { data: employee } = useGetEmployeeQuery({ id }, { skip: id === 'new' }) as { data: any }
  const { data: openTasks } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: "employee" }, objectId: { c: "EQ", v: employeeId }, solved: { c: "EQ", v: false } }), st: JSON.stringify({ id: 'desc' }) }) as any
  const { data: qualificationsWithDueDate } = useGetQualificationsQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId }, reminder: { c: "BTW", v2: dayjs().utc().format('YYYY-MM-DDTHH:mm:ss') + '.000', v: '1970-01-01T00:00:00.000', t: 'DATE' } }), st: JSON.stringify({ id: 'desc' }) }) as any
  
  const navigate = useNavigate();
 
  const tabItems: TabsProps['items'] = [
    {
      key: 'mainForm',
      label: 'Hauptmaske',
      children: <EmployeeMainForm employeeId={employeeId} employee={employee} />,
    },
    {
      key: 'tasks',
      label: openTasks?.items?.length ? <Badge count={openTasks?.items?.length || 0}><span style={{ paddingRight: "1em" }}>Todos</span></Badge> : 'Todos',
      children: <Tasks objectId={employeeId} objectType="employee" />,
      disabled: id === 'new'
    },
    {
      key: 'assignments',
      label: 'Kunden',
      children: <EmployeeAssignment employeeId={employeeId} subpage={subsubpage} />,
      disabled: id === 'new'
    },
    {
      key: 'settlement',
      label: 'Abrechnung',
      children: <EmployeeSettlement 
          employeeId={employeeId} 
          employee={employee} 
          subpage={subsubpage} 
          subSubPage={subsubsubpage} 
          setSubPage={(subSubPage: string, replace: boolean) => {
            console.log("Setting subsubpage", subSubPage);
            if(subpage === 'settlement') {
              navigate(`/employee/${id}/settlement/${subSubPage}`, { replace });
            }
          }}
           />,
      disabled: id === 'new'
    },
    {
      key: 'salary',
      label: "Gehalt",
      children: <EmployeeSalaries employeeId={employeeId} />,
      disabled: id === 'new'
    },
    {
      key: 'balance',
      label: 'Guthaben',
      children: <EmployeeBalanceSheet employeeId={employeeId} />,
      disabled: id === 'new'
    },
    {
      key: 'calendar',
      label: 'Kalender',
      children: <EmployeeCalendar employeeId={employeeId} />,
      disabled: id === 'new'
    },
    {
      key: 'qualification',
      label: qualificationsWithDueDate?.items?.length ? <Badge count={qualificationsWithDueDate?.items?.length || 0}><span style={{ paddingRight: "1em" }}>Qualifikationen</span></Badge> : 'Qualifikationen',
      children: <EmployeeQualifications employeeId={employeeId} />,
      disabled: id === 'new'
    },
    {
      key: 'abscence',
      label: "Abwesenheiten",
      children: <EmployeeAbsences employeeId={employeeId} subpage={subsubpage} />,
      disabled: id === 'new'
    },
    {
      key: 'contracts',
      label: 'Verträge',
      children: <EmployeeContracts subsubpage={subsubpage} employee={employee} employeeId={employeeId} />,
      disabled: id === 'new'
    },
    {
      key: 'comments',
      label: 'Notizen',
      children: <Comments objectId={employeeId} objectType="employee" />,
      disabled: id === 'new'
    }
  ];

  return (
    <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              onClick: () => navigate('/employee'),
              title: (
                <>
                  <IconCircleUserSolid />
                  <span>Mitarbeitende</span>
                </>
              ),
            },  
            {
              title: `${employee?.firstName ?? 'unbekannt'} ${employee?.lastName ?? ''}`
            },            
          ]}
        />
      
        <TabsStyled items={tabItems} activeKey={subpage || 'mainForm'} onChange={newSubpage => { console.log("Navigating to", `${subpage ? '../' : ''}${newSubpage}`); navigate(`/employee/${id}${newSubpage === 'mainForm' ? '' : `/${newSubpage}`}`)}} />
    </div>
  )
}

export default EmployeeDetailsPage